import { axios } from './config';

export const getAllSites = () => {
	return axios.get(`/cb/fvpDoc/all`);
};

export const getFvpConfigForSite = (siteId) => {
	return axios.get(`/cb/fvpDoc/${siteId}`);
};
export const getAllFvpDoc = () => {
	return axios.post(`/cb/fvpDoc/all`);
};

export const createFvpConfigForSite = (payload) => {
	return axios.post('/cb/fvpDoc/', payload);
};

export const updateFvpConfigInDb = (payload) => {
	return axios.put('/cb/fvpDoc/', payload);
};

export const syncFvpSite = (siteId) => {
	return axios.get(`/cb/fvpDoc/sync-site/${siteId}/`);
};

export const syncFvpBundle = () => {
	return axios.get('/cb/fvpDoc/sync-fvp-bundle/');
};

export const networkWideSync = () => {
	return axios.get('/cb/fvpDoc/network-wide-sync/');
};
